import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Text } from "@chakra-ui/react";
import AccountService from "@/services/AccountService";
import { Field, FormCheckbox } from "../ui/inputs";

// value: ids of the account's extra consents shown in this recruitment's chat; null = all of them.
const ChatConsentsSelection = ({ value, onChange, privacyEnabled, onPrivacyChange }) => {
    const { t } = useTranslation("jobOffer");
    const [consents, setConsents] = useState(null);

    useEffect(() => {
        AccountService.getChatConsents()
            .then((d) => setConsents(d?.customConsents ?? []))
            .catch(() => setConsents([]));
    }, []);

    if (!consents) return null;

    const ids = consents.map((c) => c.id);
    const selected = value ? ids.filter((id) => value.includes(id)) : ids;
    const toggle = (id, checked) => {
        const next = checked ? [...selected, id] : selected.filter((x) => x !== id);
        onChange(next.length === ids.length ? null : next);
    };

    return (
        <Field label={t("step1.basicInfo.chatConsents")}>
            <Box display="flex" flexDirection="column" gap={2}>
                <Text fontSize="sm" color="gray.600">{t("step1.basicInfo.chatConsentsAlways")}</Text>
                <FormCheckbox
                    label={t("step1.basicInfo.chatConsentsPrivacy")}
                    checked={privacyEnabled}
                    onChange={onPrivacyChange}
                />
                {consents.map((c) => (
                    <FormCheckbox
                        key={c.id}
                        label={c.required ? `${c.text} *` : c.text}
                        checked={selected.includes(c.id)}
                        onChange={(checked) => toggle(c.id, checked)}
                    />
                ))}
            </Box>
        </Field>
    );
};

export default ChatConsentsSelection;
